import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AffiliationAccessDocsComponent } from '@se-po/shared-feature-affiliation-access'
import { EditPersonaModalDocsComponent } from '@se-po/shared-feature-edit-persona-modal'
import { HouseholdGuardianInviteDocsComponent } from '@se-po/shared-feature-household-invite'
import { HouseholdReviewDocsComponent } from '@se-po/shared-feature-household-review'
import { MembershipListDocsComponent } from '@se-po/shared-feature-membership-list'
import { MergePersonaModalDocsComponent } from '@se-po/shared-feature-merge-persona-modal'
import { OrganizationListDocsComponent } from '@se-po/shared-feature-organization-list'
import { PersonaImageModalDocsComponent } from '@se-po/shared-feature-persona-image-modal'
import { RegistrationListDocsComponent } from '@se-po/shared-feature-registration-list'
import { RemovePersonaModalDocsComponent } from '@se-po/shared-feature-remove-persona-modal'
import { TeamListDocsComponent } from '@se-po/shared-feature-team-list'
import { AddChildProfileDocsComponent } from '@se-po/shared-ui-add-child-profile'
import { AddGuardianDocsComponent } from '@se-po/shared-ui-add-guardian'
import { AddressDocsComponent } from '@se-po/shared-ui-address'
import { ChildContactInfoDocsComponent } from '@se-po/shared-ui-child-contact-info'
import { ContactInfoDocsComponent } from '@se-po/shared-ui-contact-info'
import { CountrySelectDocsComponent } from '@se-po/shared-ui-country-select'
import { DisabilitySelectDocsComponent } from '@se-po/shared-ui-disability-select'
import { DobSelectDocsComponent } from '@se-po/shared-ui-dob-select'
import { EditPersonaDocsComponent } from '@se-po/shared-ui-edit-persona'
import { EmailDocsComponent } from '@se-po/shared-ui-email'
import { EthnicitySelectDocsComponent } from '@se-po/shared-ui-ethnicity-select'
import { GenderSelectDocsComponent } from '@se-po/shared-ui-gender-select'
import { GraduationSelectDocsComponent } from '@se-po/shared-ui-graduation-select'
import { GuardianInviteInfoDocsComponent } from '@se-po/shared-ui-guardian-invite-info'
import { HighlightLabelDocsComponent } from '@se-po/shared-ui-highlight-label'
import { MilitarySelectDocsComponent } from '@se-po/shared-ui-military-select'
import { NameDocsComponent } from '@se-po/shared-ui-name'
import { OverviewCardDocsComponent } from '@se-po/shared-ui-overview-card'
import { ParentContactInfoDocsComponent } from '@se-po/shared-ui-parent-contact-info'
import { PersonaAvatarDocsComponent } from '@se-po/shared-ui-persona-avatar'
import { PersonaAvatarGroupDocsComponent } from '@se-po/shared-ui-persona-avatar-group'
import { PersonaChoiceDocsComponent } from '@se-po/shared-ui-persona-choice'
import { PersonaEligibilityDocsComponent } from '@se-po/shared-ui-persona-eligibility'
import { PersonaInfoDocsComponent } from '@se-po/shared-ui-persona-info'
import { PersonaPickerDocsComponent } from '@se-po/shared-ui-persona-picker'
import { PhoneDocsComponent } from '@se-po/shared-ui-phone'
import { ProfileBarDocsComponent } from '@se-po/shared-ui-profile-bar'
import { ProfileSidePanelDocsComponent } from '@se-po/shared-ui-profile-side-panel'
import { SetupBarDocsComponent } from '@se-po/shared-ui-setup-bar'
import { StateSelectDocsComponent } from '@se-po/shared-ui-state-select'
import { SuffixSelectDocsComponent } from '@se-po/shared-ui-suffix-select'
import { RegistrationCardDocsComponent } from '@se-po/se-registration-ui-registration-card'
import { FeatureProfileSidePanelDocsComponent } from './feature-profile-side-panel-docs/feature-profile-side-panel-docs.component'
import { PrintElementServiceDocsComponent } from './print-element-service-docs/print-element-service-docs.component'
import { OverviewComponent } from './overview/overview.component'

const routes: Routes = [
  {
    path: '',
    redirectTo: 'overview',
    pathMatch: 'full'
  },
  {
    path: 'overview',
    component: OverviewComponent
  },
  {
    path: 'feature-affiliation-access',
    component: AffiliationAccessDocsComponent
  },
  {
    path: 'feature-edit-persona-modal',
    component: EditPersonaModalDocsComponent
  },
  {
    path: 'feature-household-invite',
    component: HouseholdGuardianInviteDocsComponent
  },
  {
    path: 'feature-household-review',
    component: HouseholdReviewDocsComponent
  },
  {
    path: 'feature-membership-list',
    component: MembershipListDocsComponent
  },
  {
    path: 'feature-merge-persona-modal',
    component: MergePersonaModalDocsComponent
  },
  {
    path: 'feature-organization-list',
    component: OrganizationListDocsComponent
  },
  { path: 'feature-persona-image-modal',
    component: PersonaImageModalDocsComponent
  },
  {
    path: 'feature-profile-side-panel',
    component: FeatureProfileSidePanelDocsComponent
  },
  { path: 'feature-remove-persona-modal',
    component: RemovePersonaModalDocsComponent
  },
  {
    path: 'feature-registration-list',
    component: RegistrationListDocsComponent
  },
  {
    path: 'feature-team-list',
    component: TeamListDocsComponent
  },
  {
    path: 'ui-address',
    component: AddressDocsComponent
  },
  {
    path: 'ui-add-child-profile',
    component: AddChildProfileDocsComponent,
  },
  {
    path: 'ui-add-guardian',
    component: AddGuardianDocsComponent
  },
  {
    path: 'ui-child-contact-info',
    component: ChildContactInfoDocsComponent
  },
  {
    path: 'ui-contact-info',
    component: ContactInfoDocsComponent
  },
  {
    path: 'ui-country-select',
    component: CountrySelectDocsComponent
  },
  {
    path: 'ui-disability-select',
    component: DisabilitySelectDocsComponent
  },
  {
    path: 'ui-dob-select',
    component: DobSelectDocsComponent
  },
  {
    path: 'ui-edit-persona',
    component: EditPersonaDocsComponent
  },
  {
    path: 'ui-email',
    component: EmailDocsComponent
  },
  {
    path: 'ui-ethnicity-select',
    component: EthnicitySelectDocsComponent
  },
  {
    path: 'ui-name',
    component: NameDocsComponent
  },
  {
    path: 'ui-overview-card',
    component: OverviewCardDocsComponent,
  },
  {
    path: 'ui-registration-card',
    component: RegistrationCardDocsComponent
  },
  {
    path: 'ui-gender-select',
    component: GenderSelectDocsComponent
  },
  {
    path: 'ui-graduation-select',
    component: GraduationSelectDocsComponent
  },
  {
    path: 'ui-guardian-invite-info',
    component: GuardianInviteInfoDocsComponent
  },
  {
    path: 'ui-highlight-label',
    component: HighlightLabelDocsComponent
  },
  {
    path: 'ui-military-select',
    component: MilitarySelectDocsComponent
  },
  {
    path: 'ui-parent-contact-info',
    component: ParentContactInfoDocsComponent
  },
  {
    path: 'ui-persona-avatar',
    component: PersonaAvatarDocsComponent
  },
  {
    path: 'ui-persona-avatar-group',
    component: PersonaAvatarGroupDocsComponent
  },
  {
    path: 'ui-persona-choice',
    component: PersonaChoiceDocsComponent
  },
  {
    path: 'ui-persona-eligibility',
    component: PersonaEligibilityDocsComponent
  },
  {
    path: 'ui-persona-info',
    component: PersonaInfoDocsComponent
  },
  {
    path: 'ui-persona-picker',
    component: PersonaPickerDocsComponent
  },
  {
    path: 'ui-phone',
    component: PhoneDocsComponent
  },
  {
    path: 'ui-profile-bar',
    component: ProfileBarDocsComponent
  },
  {
    path: 'ui-profile-side-panel',
    component: ProfileSidePanelDocsComponent
  },
  {
    path: 'util-print-element-service',
    component: PrintElementServiceDocsComponent
  },
  {
    path: 'ui-setup-bar',
    component: SetupBarDocsComponent
  },
  {
    path: 'ui-state-select',
    component: StateSelectDocsComponent
  },
  {
    path: 'ui-suffix-select',
    component: SuffixSelectDocsComponent
  },
]

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class SharedDocsRoutingModule {}
